// extracted by mini-css-extract-plugin
module.exports = {"qrReader":"Scan_qrReader__LRh7P"};